<template>
  <div class="navbar-container">
    <div v-if="isMobileView" class="logo-container">
      <div class="font-weight-black">{{ title }}</div>
    </div>
    <div v-else class="title font-weight-black">
      {{ title }}
    </div>
    <div class="toolbar">
      <div v-if="dateFilter" class=" date-picker-container d-flex justify-center">
        <v-date-input v-model="selectedDateRange" :label="$t('i18n.datePickerLabel')" :ok-text="$t('i18n.datePickerOk')"
          :cancel-text="$t('i18n.datePickerCancel')" min-width="19em" multiple="range" hide-details="auto"
          variant="outlined" density="compact" color="black" single-line clearable clear-icon="mdi-close-circle"
          :max="maxDate" @update:modelValue="emitSelectedDateRange" @click:clear="clearDateRange"></v-date-input>
        <v-tooltip activator="parent" location="start">
          {{ $t('i18n.datePicker') }}
        </v-tooltip>
      </div>
      <v-text-field v-if="!isMobileView && searchBar" class="search-bar" min-width="18em" v-model="searchQuery"
        :placeholder="searchBarPlaceholder" @input="emitSearch" append-inner-icon="mdi-magnify" hide-details single-line
        variant="outlined" density="compact">
      </v-text-field>
      <v-text-field v-if="isMobileView && searchBar" class="search-bar" min-width="19em" v-model="searchQuery" :placeholder="searchBarPlaceholder"
        @input="emitSearch" append-inner-icon="mdi-magnify" hide-details single-line variant="outlined"
        density="compact">
      </v-text-field>
      <div v-if="button" class="action-button">
        <v-btn class="gorate-btn-bg" rounded="xl" variant="flat" @click="handleNavBarClick">{{ buttonText }}</v-btn>
      </div>
    </div>
    <div v-if="isMobileView" class="avatar-container">
        <UserAvatar />
      </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import UserAvatar from '../misc/UserAvatar.vue'

export default defineComponent({
  name: 'ContentContainerNavBar',
  components: {
    UserAvatar
  },
  props: {
    title: {
      type: String,
      required: true,
      default: 'N/A'
    },
    searchBarPlaceholder: {
      type: String,
      required: false,
      default: 'Search'
    },
    button: {
      type: Boolean,
      required: false,
      default: false
    },
    dateFilter: {
      type: Boolean,
      required: false,
      default: false
    },
    searchBar: {
      type: Boolean,
      required: false,
      default: false
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Button'
    },
    buttonEvent: {
      type: String,
      required: false,
      defaut: 'navbar-btn-click'
    }
  },
  setup () {
    const isMobileView = ref(window.innerWidth < 960)

    const updateView = () => {
      isMobileView.value = window.innerWidth < 960
    }

    onMounted(() => {
      window.addEventListener('resize', updateView)
    })

    return {
      isMobileView
    }
  },
  data () {
    return {
      searchQuery: '',
      selectedDateRange: [] as Date[]
    }
  },
  methods: {
    emitSearch () {
      this.$emit('search-input', this.searchQuery)
    },
    emitSelectedDateRange () {
      /* console.log('Date range: ', this.selectedDateRange) */
      try {
        if (Array.isArray(this.selectedDateRange) && this.selectedDateRange.length > 0) {
          const startDate = new Date(this.selectedDateRange[0])
          const endDate = new Date(this.selectedDateRange[this.selectedDateRange.length - 1])
          startDate.setHours(0, 0, 0, 0)
          endDate.setHours(23, 59, 59, 999)
          this.$emit('date-range-input', { startDate, endDate })
        }
      } catch (error) {
        console.error('Error selecting date range: ', error)
      }
    },
    clearDateRange () {
      this.selectedDateRange = []
      this.$emit('date-range-input', null)
    },
    handleNavBarClick () {
      if (this.buttonEvent !== undefined) {
        this.$emit(this.buttonEvent)
      } else {
        this.$emit('navbar-btn-click')
      }
    }
  },
  computed: {
    maxDate () {
      const today = new Date()
      return today.toISOString().split('T')[0]
    }
  }
})
</script>

<style lang="scss" scoped>
@import "../../styles/colors.scss";

.navbar-container {
  grid-row: 1;
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  align-items: center;

  padding: 0em 1.0em;

  min-height: 4em;

  background-color: $white;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);

  .navbar-title {
    padding: 0.8em 0.4em 0.8em 2.0em;
    font-weight: bold;
  }

  .toolbar {
    display: grid;
    grid-template-columns: auto auto auto;
    align-items: center;

    .search-bar {
      padding: 0 1.4em;
    }

  }
}

/* MOBILE */
@media (max-width: 960px) {

  .navbar-container {
    display: grid;
    grid-template-columns: auto 1fr;
    /* grid-template-rows: min-content 1fr; */
    align-items: center;

    .logo-container {
      grid-row: 1;
      grid-column: 1;
    }

    .avatar-container {
      grid-row: 1;
      grid-column: 2;
      justify-self: end;
    }

    .toolbar {
      grid-row: 2;
      grid-column: 1 / 3;

      display: grid;
      grid-template-rows: repeat(3, auto);

      .search-bar {
        grid-row: 1;
        grid-column: 1 / 4;
        padding: 0 0 0.4em 0;
        text-align: start;
      }

      .date-picker-container {
        grid-row: 2;
        grid-column: 1 / 4;
        padding: 0 0 0.4em 0;
      }

      .action-button {
        grid-row: 3;
        grid-column: 1 / 4;
        padding: 0.4em 0 0.8em 0;
      }
    }
  }

}
</style>
